module.exports = __webpack_public_path__ + "b88c8ddd2daa66c0c40248a75129ca94.svg";